// extracted by mini-css-extract-plugin
export var black = "_1f-6";
export var brand = "_1f-1";
export var ddefault = "_1f-0";
export var error = "_1f-3";
export var gray = "_1f-2";
export var highContrast = "_1f-8";
export var outline = "_1f-7";
export var success = "_1f-5";
export var warning = "_1f-4";